<template>
  <Modal v-model="addBillOfLadingGoodsModal" class-name="addBillOfLadingGoodsStyle" :title="$t('key1001092')" :width="1200"
    :transfer="false" :mask-closable="false" @on-visible-change="addBillOfLadingGoodsChange">
    <div class="details_box_styles">
      <!--树状分类模块-->
      <commonTree ref="treeDom" @selectCategory="selectCategory"></commonTree>
      <!--商品列表-->
      <Card class="content_box" dis-hover :bordered="false">
        <Form ref="pageParams" :model="pageParams" @submit.native.prevent class="mb20">
          <Row type="flex" :gutter="gutterItem">
            <Col span="10">
              <dropDownFilter
                :transfer="false"
                ref="dropDownFilter"
                inputType="textarea"
                :selectStyle="{width: '110px'}"
                :dropDownInputList="dropDownInputList"
                :defaultSelectValue="defaultSelectValue"
                @changeInput="changeInput"
                @updateInputValue="updateInputValue">
              </dropDownFilter>
            </Col>
            <Col style="min-width: 170px;" push="1">
              <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
              <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
            </Col>
          </Row>
        </Form>
        <!--列表区域-->
        <div class="table_box">
          <Table
            ref="selection"
            highlight-row
            border
            max-height="460"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="tableData"
            @on-selection-change="getSelectValue">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="total"
            @on-change="changePage"
            show-total
            :page-size="pageParams.pageSize"
            show-elevator
            :current="pageParams.pageNum"
            show-sizer
            @on-page-size-change="changePageSize"
            placement="top"
            :page-size-opts="pageArray">
          </Page>
        </div>
      </Card>
    </div>
    <template #footer>
      <Button @click="addBillOfLadingGoodsModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="selectTableData.length <=0" @click="addProductBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import commonTree from "@/components/common/commonTree.vue";
import dropDownFilter from "@/components/common/dropDownFilter.vue";

export default {
  name: 'addBillOfLadingGoodsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      addBillOfLadingGoodsModal: false,
      pageParams: {
        ymsSkus: '',
        ymsSpus: '',
        supplierSkus: '',
        supplierSpus: '',
        ymsProductCategoryIdList: [],
        vestMerchantId: null,
        merchantType: 1,
        searchValue: '',
        ymsProductIds: [],
        pageNum: 1,
        pageSize: 15,
      },
      total: 0,
      dropDownInputList: [
        {title: 'YMSSKU', value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003972'), parameterKey: 'ymsSkus'},
        {title: 'YMSSPU', value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003973'), parameterKey: 'ymsSpus'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003974'), parameterKey: 'supplierSkus'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001093'), value: 4, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003975'), parameterKey: 'supplierSpus'},
      ],
      defaultSelectValue: 1,
      selectTableData: [],
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 320,
          key: 'goodsInfo',
          align: 'left',
          render: (h, params) => {
            let imagePath = params.row.primaryImage;
            let supplierSpu = params.row.supplierSpu;
            let ymsSpu = params.row.ymsSpu;
            let name = params.row.name;
            let list = [
              v.tableImg(h, params, null, imagePath),
              h('div', {class: 'flex flex-direction ml10'}, [
                h('div', [
                  h('Alink', {
                    props: {
                      linkName: name,
                      textAlign: 'left',
                      AlinkClass: 'ellipsis_2'
                    },
                    on: {
                      AlinkBtn: () => {
                        const {href} = v.$router.resolve({
                          path: '/productDetails',
                          query: {
                            type: 'look',
                            productId: params.row.ymsProductId
                          }
                        });
                        window.open(href, '_blank');
                      }
                    }
                  }),
                ]),
                [
                  h('p', {class: 'mt5'}, 'YMSSPU：' + ymsSpu),
                  h('p', {class: 'mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000600') + supplierSpu),
                ]
              ])
            ];
            return h('div', {class: 'flex ptb10'}, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          minWidth: 240,
          key: 'skuInfo',
          align: 'left',
          render: (h, params) => {
            let ymsSku = params.row.ymsSku;
            let supplierSku = params.row.supplierSku;
            let productGoodsSpecifications = params.row.productGoodsSpecifications || [];
            let spec = productGoodsSpecifications.map(i => i.value).join('、') || '';
            let list = [
              h('div', {class: 'flex flex-direction ml10'}, [
                h('div', [
                  h('p', {class: 'mt5'}, 'YMSSKU：' + ymsSku),
                  h('p', {class: 'mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003976') + supplierSku),
                  h('p', {class: 'color-green'}, spec)
                ])
              ])
            ];
            return h('div', {class: 'flex ptb10'}, list);
          }
        },
      ],
      tableData: [],
    }
  },
  computed: {
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey
      });
    }
  },
  methods: {
    // 初始化数据
    initAddBillOfLadingGoodsData(obj) {
      let {storageType, vestMerchantId, merchantType} = obj;
      if (storageType === 3) {
        this.pageParams.isSelfOperated = 1;
      }
      this.pageParams.vestMerchantId = vestMerchantId;
      this.pageParams.merchantType = merchantType;
      this.$refs['treeDom'].getClassificationData(true);
      this.addBillOfLadingGoodsModal = true;
    },
    // 选中分类查询
    selectCategory(data) {
      this.pageParams.ymsProductCategoryIdList = data[0] ? data[0].ymsProductCategoryId === -1 ? [] : [data[0].ymsProductCategoryId] : [];
      this.search();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      if (v.$refs['pageParams']) {
        v.$refs['pageParams'].resetFields();
        v.pageParams.ymsProductCategoryIdList = [];
      }
      v.selectTableData = [];
      v.changeInput(1);
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.selectTableData = [];
      v.tableLoading = true;
      v.axios.post(api.post_productGoods_queryGoodsPageInfo, v.handleParameter()).then(response => {
        if (response.data.code === 0) {
          v.tableLoading = false;
          let data = response.data.datas;
          v.$refs['selection'].selectAll(false);
          if (data) {
            v.tableData = data.list || [];
            v.total = data.total;
          }
        } else {
          v.tableLoading = false;
        }
      });
    },
    // 获取列表勾选的数据
    getSelectValue(value) {
      this.selectTableData = value;
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 确定按钮
    addProductBtn() {
      if (this.selectTableData.length <= 0) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003336'));
        return false;
      }
      this.selectTableData.map((item) => {
        item.quantity = 1;
      });
      this.$emit('updateProductsData', this.selectTableData);
      this.addBillOfLadingGoodsModal = false;
    },
    // 监听弹窗
    addBillOfLadingGoodsChange(value) {
      if (!value) {
        this.reset();
        this.$refs['selection'].selectAll(false);
        this.tableData = [];
        this.pageParams = {
          ymsSkus: '',
          ymsSpus: '',
          supplierSkus: '',
          supplierSpus: '',
          ymsProductCategoryIdList: [],
          vestMerchantId: null,
          merchantType: 1,
          searchValue: '',
          ymsProductIds: [],
          pageNum: 1,
          pageSize: 15,
        }
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      if (value) {
        this.getList();
        this.pageParamsStatus = false;
      }
    }
  },
  components: {
    dropDownFilter,
    commonTree
  }
};
</script>

<style lang="less" scoped>
/deep/ .addBillOfLadingGoodsStyle {
  .details_box_styles {
    min-height: 624px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .content_box {
      width: 78%;

      .ivu-card-body {
        padding: 0 !important;
      }
    }
  }
}
</style>
